import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import OrderAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order/order.entity";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, TemplateRef, ViewChild, inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogModule,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { IPaginationResult, IPaginationResultFrequencies } from "app/common/interfaces/pagination-result.interface";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { OrdersListService } from "app/modules/components/sales/order-list-components/order-list.service";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { distinctUntilChanged } from "rxjs/internal/operators/distinctUntilChanged";
import { PrincipalScreenService } from "../../principal-screen/principal-screen.service";
import { getCode } from "app/utils/method";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { MatMenuModule } from "@angular/material/menu";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DocumentClassService } from "app/modules/components/document/document-class/document-class.service";
import { DocumentClassAttributes, OrderDetailAttributes, OrderExtraStatusAttributes } from "@albatrosdeveloper/ave-models-package";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ICreateDocumentTransport } from "../interfaces/create-transport-document.interface";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { environment } from "environments/environment.prod";
import { SalesOfficeService } from "app/modules/components/configuration/sales-office/sales-office.service";
import { lastValueFrom } from "rxjs";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { ManualLabelSelectionIndicatorComponent } from "app/shared/components/manual-label-selection-indicator";
import { BatchesDetailDialogService } from "app/modules/shared/batches-detail/batches-detail-dialog.service";

@Component({
    selector: "app-modal-transport",
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatProgressBarModule,
        MatIconModule,
        MatSelectModule,
        MatCardModule,
        MatSortModule,
        MatTableModule,
        FormatOtherDateHourPipe,
        MatMenuModule,
        MatCheckboxModule,
        MatPaginatorModule,
        FormsModule,
        NgxMatSelectSearchModule,
        NgOptionTemplateDirective,
        MatOptionModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
        NgSelectModule,
        MatDatepickerModule,
        MatTabsModule,
        NgxMatSelectSearchModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        DecimalFormatPipe,
        UnitMeasureDisplayComponent,
        ManualLabelSelectionIndicatorComponent
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
    templateUrl: "./modal-transport.component.html",
    styleUrl: "./modal-transport.component.scss",
    animations: [
        trigger("detailExpand", [
            state("collapsed,void", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
            ),
        ]),
    ],
})
export class ModalTransportComponent {
  private readonly batchesDialog = inject(BatchesDetailDialogService);

  /** El tipo del documento decide si se muestran los lotes entregados o los cargados. */
  hasBatches(detail: any): boolean {
    return this.batchesDialog.hasBatches(this.selectedOrder?.type?.code, detail);
  }

  openBatchesDetail(order: any, detail: any): void {
    this.batchesDialog.open(order, detail);
  }
    projectName = environment.projectName;
    getCode = getCode
    StatusEnum = StatusEnum
    OrderStatusERPEnum = OrderStatusERPEnum
    type = DocumentTypeEnum.ENTREGA_SALIDA
    dataSource = new MatTableDataSource<OrderAttributes>([]);
    displayedColumns: string[] = [
        "det",
        "check",
        "status",
        "statusERP",
        "type",
        "soldTo",
        "documentNumber",
        "class",
        "subTotal",
        "total",
        "creation",
        "loadDateTime",
        // "actions",
    ];

    displayedColumnsDetail: string[] = [
        "material",
        "note",
        "warehouse",
        "soldQuantity",
        "unitPrice",
        "subTotal",
        "totalSurcharges",
        "totalDiscounts",
        "tax",
        "total",
        //"actions",
      ];

    totalItems: number = 0;
    searchControl = new FormControl('');
    search: string = '';
    pageSize: number = 50;
    pageIndex: number = 1;
    sortActive: keyof OrderAttributes = "createdAt";
    sortDirection: "asc" | "desc" = "desc";


    selection = new SelectionModel<any>(true, []);
    selectedOrder: OrderAttributes | null = null;
    dataSourceDetail = new MatTableDataSource<OrderDetailAttributes>([]);
    companies: CompanyAttributes[] = [];
    companyList: CompanyAttributes[] = [];
    UMPActive: boolean;

    //Filter
    selectedStartDate: Date;
    selectedEndDate: Date;
    dateRange: FormGroup;

    interval;
    timeInterval = 60000 * 15
    showInterval: boolean = false;

    documentClassList: DocumentClassAttributes[] = [];
    listFilterdocumentClassList: DocumentClassAttributes[] = [];
    selectedDocumentClassIds: string[] = [];
    isGlobalSynchronizeAvailable: boolean = false;
    searchEmissionPoint = ''

    currentCreateDocument: ICreateDocumentTransport =
        this.initializeCreateDocument();

    @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;
    constructor(
        private ordersListService: PrincipalScreenService,
        private readonly companyService: CompanyService,
        private readonly snackBar: MatSnackBar,
        private dialog: MatDialog,
        private readonly salesOfficeService: SalesOfficeService,
        private readonly warehouseService: WarehouseService,
        private documentClassService: OrdersListService,
        private readonly docClassService: DocumentClassService,
        private readonly cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<ModalTransportComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngAfterViewInit(): void {
        this.onFilter();
        this.fetchCompanies();
        this.fetchAllDocument();

        this.searchControl.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((filterValue: string) => {
                this.pageIndex = 1;
                this.search = filterValue;
                this.getList();
            });
    }

    private initializeCreateDocument(): ICreateDocumentTransport {
        return {
            serial: [],
            tripId: ""
        };
    }

    private fetchCompanies(): void {
        this.companyService.findToComboBox().subscribe((res) => {
            this.companyList = res.data;
            if (res.data.length === 1) {
                this.UMPActive = res.data[0].UMPActive
            }
        });
    }

    onFilter() {
        if (this.showInterval) {
            if (this.interval) {
                clearInterval(this.interval)
            }
            this.getList()

            this.interval = setInterval(() => {
                this.getList()
            }, this.timeInterval);
        } else {
            this.getList()
        }
    }

    getList() {
        this.resetSelection();
        this.isGlobalSynchronizeAvailable = false;
        const sortField = this.getSortField();
        const sortDirection: "ASC" | "DESC" = this.sortDirection === "asc" ? "ASC" : "DESC";

        // Parámetros consolidados
        const params = {
            currentPage: this.pageIndex,
            limitPerPage: this.pageSize,
            search: this.search,
            sort: sortField || "createdAt", // Usa sortField si existe, sino "createdAt"
            sortDirection: sortDirection
        };
        this.ordersListService.findAllWithCountForDocument(
            params,
            this.data.id,
            [this.type],
            [],
            true
        ).subscribe({
            next: (res: IPaginationResult<OrderAttributes>) => {
                this.dataSource.data = res?.data[0]?.data ?? [];
                this.totalItems = res?.data[0]?.pageInfo?.[0]?.total ?? 0;
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener información de los pedidos por documento.","Cerrar",{ duration: 5000});
            },
        })
    }

    synchronizeDates(): void {
        this.selectedStartDate = this.dateRange.get('start')?.value;
        this.selectedEndDate = this.dateRange.get('end')?.value;
    }

    resetSelection() {
        this.selection.clear()
    }

    isAllSelected() {
        const validRows = this.dataSource.data.filter(row =>
            this.validateDataToSynchronize(row)
        );

        const numSelected = this.selection.selected.length;
        const numValidRows = validRows.length;
        return numSelected === numValidRows && numValidRows > 0;
    }

    validateDataToSynchronize(order: OrderAttributes) {
        return order
    }

    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    masterToggle() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => {
            if ((
                this.validateDataToSynchronize(row)
            ))
                this.selection.select(row)
        });
    }

    onCheckboxChange(event, element?): void {
        let auxSelected = this.selection.selected;
        this.isGlobalSynchronizeAvailable =
            auxSelected.length > 0 &&
            auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
            0;
    }


    private getSortField(): keyof OrderAttributes {
        const sortFieldMapping: Record<string, keyof OrderAttributes> = {
            status: "statusERP",
            type: "type",
            trip: <any>"trip.id",
            subRoute: <any>"subRoute.name",
            user: <any>"user.user_login.username",
            soldTo: <any>"soldTo.name",
            documentNumber: "serial",
            class: <any>"class.name",
            date: "deliveryDateTime",
            creation: "creationDateTime",
        }
        return sortFieldMapping[this.sortActive] || "creationDateTime";
    }

    iconConfig = {
        DT009: {
            icon: "heroicons_solid:exclamation-circle",
            iconType: "svg",
            tooltip: "En espera de aprobación",
            color: "rgb(236, 199, 58)",
        },
        DT010: {
            icon: "heroicons_solid:exclamation-circle",
            iconType: "svg",
            tooltip: "En espera de aprobación",
            color: "rgb(236, 199, 58)",
        },
        DT013: {
            icon: "local_shipping",
            iconType: "font",
            tooltip: "En espera de recolección",
            color: "rgb(236, 199, 58)",
        },
        DT012: {
            icon: "swap_vert",
            iconType: "font",
            tooltip: "En espera de cambio de producto",
            color: "rgb(236, 199, 58)",
        },
        default: {
            icon: "heroicons_solid:check-circle",
            iconType: "svg",
            tooltip: "Creado",
            color: "rgb(65, 106, 218)",
        },
    };

    getIconConfig(code: string) {
        return this.iconConfig[code] || this.iconConfig.default;
    }

    changeSort(e) {
        this.sortActive = e.active
        this.sortDirection = e.direction
        this.getList()
    }

    changePage(e: PageEvent) {
        this.pageIndex = (e.pageIndex + 1)
        this.pageSize = e.pageSize
        this.getList()
    }


    openConfirmDialog(order: OrderAttributes): void {
        this.dialog
            .open(this.confirmDialog, {
                data: order,
                panelClass: "delete-modal",
                disableClose: true
            })
            .afterClosed()
            .subscribe(
                (result) => result && this.generateDocument(order)
            );
    }

      onCancel(): void {
        this.dialogRef.close({...this.data, confirmed: false});
    }

    private fetchAllDocument(documentType?: string) {
        let dataToFilter = {
            type: DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE,
        };
        this.documentClassService
            .fetchDocumentClasses(dataToFilter)
            .subscribe((res) => {
                this.documentClassList = res.data;
                this.listFilterdocumentClassList = this.documentClassList.slice();
            });
    }

    changueOptionsDocumentClass(event) {
        if (!this.documentClassList) {
            return;
        }
        let search = event;
        if (!search) {
            this.listFilterdocumentClassList = this.documentClassList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        this.listFilterdocumentClassList = this.documentClassList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
    }


    async getDocumentClass(order: OrderAttributes) {
        const documentClass: DocumentClassAttributes = await lastValueFrom(
            this.docClassService.findOne(String(order.class._id))
        ).then((res) => res.data);
        if (documentClass) order.class = documentClass;
        this.cdr.detectChanges();
    }

    getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
        const status = list.find((i) => i.type == type);
        return status?.description || "-";
    }

    async toggleDetails(order: OrderAttributes): Promise<void> {
        if (this.selectedOrder && this.selectedOrder._id === order._id) {
            this.closeDetails();
            return;
        }

        this.selectedOrder = order;
        this.dataSourceDetail.data = this.selectedOrder.detail || [];
        // Obtiene compañía para hacer uso de flags
        const companyFound: CompanyAttributes = this.companies.find(
            (c) => c.id == this.selectedOrder.company?.id
        );
        if (companyFound) this.selectedOrder.company = companyFound;

        // Obtiene almacenes y clase de documento
        const orderStatusId = this.selectedOrder.statusId;
        if (orderStatusId != StatusEnum.INACTIVE && orderStatusId != StatusEnum.ORDER_APPROVED && orderStatusId != StatusEnum.ORDER_REJECTED) {        
            await this.getDocumentClass(this.selectedOrder);

            if (
                this.selectedOrder.class["showCurrentStockForMaterials"] == true &&
                !this.selectedOrder["warehousesToUpdate"]
            ) {
                const salesOffice: Partial<SalesOfficeAttributes> = await lastValueFrom(
                    this.salesOfficeService.findOne(
                        this.selectedOrder.salesOffice._id.toString()
                    )
                ).then((res) => res.data);
                if (salesOffice && salesOffice.warehouses) {
                    let filter = {
                        officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
                        company: [environment.companyId],
                    };
                    this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
                        this.warehouseService.filterComboBox(filter)
                    ).then((res) => res.data);
                }
            }
        }
    }

    closeDetails(): void {
        this.selectedOrder = null;
    }

    generateDocument(order: OrderAttributes) {
        this.currentCreateDocument.tripId = this.data._id;
        if (order) {
            this.currentCreateDocument.serial.push(order._id.toString());
        } else {
            // Caso 2: Selección múltiple
            this.selection.selected.forEach((o) => {

                this.currentCreateDocument.serial.push(o._id.toString());

            });
        }

        const requests = [];
        if (this.currentCreateDocument.serial.length > 0) {
            requests.push(
                this.documentClassService.generateDocumentTransport(this.currentCreateDocument as any).toPromise()
            );
        }
        Promise.all(requests)
            .then(() => {
                this.snackBar.open("Registro generado con éxito", "Cerrar", {
                    duration: 3000,
                });
                //   this.refreshMonitor.emit();
                this.getList();
            })
            .catch((err) => {
                this.snackBar.open(err.error.message || "Error al generar documento.","Cerrar",{ duration: 5000});
            });
    }
}


